const ALERTS = {
  'alert.torrent.add': `Successfully added {countElement} {count, plural,
    =1 {torrent}
    other {torrents}
  }.`,
  'alert.torrent.add.failed': `Failed to add {countElement} {count, plural,
    =1 {torrent}
    other {torrents}
  }.`,
  'alert.torrent.move': `Successfully moved {countElement} {count, plural,
    =1 {torrent}
    other {torrents}
  }.`,
  'alert.torrent.move.failed': `Failed to move {countElement} {count, plural,
    =1 {torrent}
    other {torrents}
  }.`,
  'alert.torrent.remove': `Successfully removed {countElement} {count, plural,
    =1 {torrent}
    other {torrents}
  }.`,
  'alert.torrent.remove.failed': `Failed to remove {countElement} {count, plural,
    =1 {torrent}
    other {torrents}
  }.`,
  'alert.settings.saved': 'Successfully saved settings.',
};

export default ALERTS;



// WEBPACK FOOTER //
// ./client/src/javascript/constants/Alerts.js